import { render, staticRenderFns } from "./Age_Official.vue?vue&type=template&id=1a591cff"
import script from "./Age_Official.vue?vue&type=script&lang=js"
export * from "./Age_Official.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports